module.exports = __webpack_public_path__ + "static/media/slider_prev_button.d855ff1d.svg";